import React from "react";
import { toElementProps } from "../../Element.js";

export function TermsOfUseStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .terms-of-use": {
            display: "grid",
            gridGap: "8px",
            textAlign: "end",

            gridColumnStart: 1,
            gridColumnEnd: 3,

            "& .link": {
                textDecoration: "none",

                "&:hover": {
                    textDecoration: "underline",
                },
            },

            [MobileBreakpoint]: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",

                "& .link": {
                    padding: "10px 8px",
                },
            },
        },
    };
}

export default function TermsOfUse(props) {
    const { Legacy } = props.variables;

    if (!Array.isArray(Legacy)) {
        console.warn("Legacy is not array!");
        return null;
    }

    if (Legacy.length === 0) {
        return null;
    }

    const elProps = toElementProps(props, { className: ["terms-of-use"] });
    return (
        <div {...elProps}>
            {Legacy?.map(
                ({ title, link }) =>
                    link && (
                        <a key={title} className="link" href={link} target="_blank">
                            {title}
                        </a>
                    )
            )}
        </div>
    );
}
